/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('Vat_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBooking = $resource( baseUrl +'rest/vats/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET'}

        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Vat',["Vat_Resource","VatData", function (Vat_Resource,VatData)
    {
        var  Vat = function (resource)
        {
            this.id = null;
            this.isDeleted = false;
            this.code = null;
            this.tax = null;
            this.isDefault = null;
            this.isUsable = null;
            this.version = null;
            this.loadObject(resource);
            VatData.add(this);
        }
        Vat.prototype.loadObject = function(object)
        {
            if (object!==undefined && object!=null)
            {
                if (!this.id)
                    this.id = object.id;
                this.isDeleted = object.isDeleted;
                this.code = object.code;
                this.tax = object.tax;
                this.isDefault = object.isDefault;
                this.isUsable = object.isUsable;
                if (object.version)
                    this.version = object.version;
            }
        }
        Vat.prototype.getObjectResource = function()
        {
            var rsVat = new Vat_Resource();
            rsVat.id = this.id;
            rsVat.isDeleted = this.isDeleted;
            rsVat.code = this.code;
            rsVat.tax = this.tax;
            rsVat.isDefault = this.isDefault;
            rsVat.isUsable = this.isUsable;
            return rsVat;
        }

        Vat.prototype.getId = function()
        {
            return this.id;
        }

        Vat.prototype.setId = function(id)
        {
            this.id = id;
        }

        return Vat;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('VatSrv',["$log","Vat_Resource","UserActionData","Vat","VatData","ServerSrv",
        function ($log,Vat_Resource,UserActionData,Vat,VatData,ServerSrv)
        {
        var  vatSrv = {};

        vatSrv.query = function(successFunction,errorFunction)
        {
            Vat_Resource.query(
                {}, //params
                function (data) {   //success
                    VatData.clear() ;
                    for (var i=0;i< data.length;i++)
                        new Vat(data[i]);//Auto Add to VatData
                    if (successFunction!== undefined)
                        successFunction(VatData.indexVats);

                },
                function (data) {   //failure
                    $log.error("Vat_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        vatSrv.save = function(vat,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(vatSrv.saveSync, vat, successFunction, errorFunction);
        };
        vatSrv.saveSync = function(vat,successFunction,errorFunction)
        {
            //$timeout (function () {

            var VatRes = vat.getObjectResource();
            VatRes.$save({}, //no params
                function (data) {
                    try{
                        vat.setId(data.id);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        vatSrv.remove = function(vat,successFunction,errorFunction)
        {
            VatData.remove(vat);
            ServerSrv.startSavingProcess(vatSrv.removeSync, vat, successFunction, errorFunction);
        };
        vatSrv.removeSync =  function(vat,successFunction,errorFunction)
        {
            //$timeout (function () {

            var vatSrv = new Vat_Resource();
            vatSrv.$remove({id:vat.getId()}, //params : id
                function (data) {
                    try{
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        vatSrv.restore = function(vat,successFunction,errorFunction)
        {
            VatData.restore(vat);
            ServerSrv.startSavingProcess(vatSrv.restoreSync, vat, successFunction, errorFunction);
        };
        vatSrv.restoreSync = function(vat,successFunction,errorFunction)
        {
            //$timeout (function () {

            var VatRes = vat.getObjectResource();
            VatRes.$save({}, //no params
                function (data) {
                    try{
                        vat.setId(data.id);
                        if (!vat.version || (data.version && data.version > vat.version))
                            vat.version = data.version;
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        vatSrv.get =  function(id,successFunction,errorFunction)
        {
            Vat_Resource.get(
                {id:id}, //params
                function (vatResource) {
                    if (successFunction!=undefined)
                        successFunction(new Vat(vatResource));
                },
                function (data) {
                    if (errorFunction !=undefined)
                        errorFunction(data);
                });
        };

        vatSrv.updateLocally =  function(id,resource)
        {
            var vat =  VatData.getById(id)
            if (vat!=null)
                vat.loadObject(resource);
            return vat;
        };
        vatSrv.removeLocally =  function(id,resource)
        {
            var vat =  VatData.getById(id)
            if (vat!=null)
                VatData.remove(vat);
            return vat;
        };
        vatSrv.addLocally =  function(id,resource)
        {
            var vat =  VatData.getById(id);
            if (vat!=null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                vat.loadObject(resource);
                VatData.add(vat);
            }
            else
            {
                vat = new Vat(resource);
                vat.id = id;
            }
            return vat;
        };

        return vatSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('VatData',["$filter", function ($filter)
    {
        var  vatDataSrv =
        {
            indexVats : [],
            activeVats : [],
            deletedVats : []//deleted items
        };
        vatDataSrv.getById =  function(vatId)
        {
            for (var i=0;i<this.indexVats.length;i++)
                if (this.indexVats[i].getId()==vatId)
                    return this.indexVats[i];
            return null;
        }
        vatDataSrv.getDefaultVat = function(){
            for (var i=0;i<this.indexVats.length;i++)
                if (this.indexVats[i].isDefault)
                    return this.indexVats[i];
            return null;
        }
        vatDataSrv.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexVats.length)
                return this.indexVats[index];
            return null;
        }
        vatDataSrv.getIndexOf =  function(vat)
        {
            if (vat)
                return this.indexVats.indexOf(vat);
            return -1;
        }

        vatDataSrv.add =  function(vat)
        {
            var vatArray = this.activeVats;
            if (vat.isDeleted)
                vatArray =  this.deletedVats;
            var index =  this.indexVats.indexOf(vat);
            if (index!=-1)
            {
                var realIndex = vatArray.indexOf(vat);
                if (realIndex==-1)
                    vatArray.push(vat);
            }
            else
            {
                index = this.indexVats.length
                this.indexVats.push(vat);
                vatArray.push(vat);
            }
            return index;
        }        
        vatDataSrv.remove =  function(vat)
        {
            var index =  this.activeVats.indexOf(vat);
            if (index!=-1)
            {
                this.activeVats.splice(index, 1);
                this.deletedVats.push(vat)
                vat.isDeleted=true;
            }
        }
        vatDataSrv.restore =  function(vat)
        {
            var index =  this.deletedVats.indexOf(vat);
            if (index!=-1)
            {
                this.deletedVats.splice(index, 1);
                this.activeVats.push(vat);
                vat.isDeleted=false;
            }
        }
        vatDataSrv.clear =  function()
        {
            this.indexVats = [];
            this.activeVats = [];
            this.deletedVats = [];
        }
        vatDataSrv.sort =  function()
        {
            this.activeVats = $filter('orderBy')(this.activeVats,'code', false);
            this.deletedVats = $filter('orderBy')(this.deletedVats,'code', false);
        }

        vatDataSrv.getActiveList =  function()
        {
            return this.activeVats;
        }
        vatDataSrv.getDeletedList =  function()
        {
            return this.deletedVats;
        }
        return   vatDataSrv;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/Vat.js